import { getCountryConfig } from "@/config/countries";
import { txRead } from "@/lib/persistence/transactionalStore";
import { DEFAULT_APP_LANGUAGE, isAppLanguage } from "./engine";
import type { AppLanguage } from "./types";

interface StoredLanguageSelection {
  pais?: unknown;
  idioma?: unknown;
}

const BUSINESS_CONFIG_KEY = "businessConfig";

/** Resuelve la preferencia explícita o el idioma regional del país activo. */
export function getActiveLanguage(): AppLanguage {
  const config = txRead<StoredLanguageSelection>(BUSINESS_CONFIG_KEY, {});
  if (isAppLanguage(config.idioma)) return config.idioma;

  const regionalLanguage = getCountryConfig(config.pais).defaultLanguage;
  return isAppLanguage(regionalLanguage)
    ? regionalLanguage
    : DEFAULT_APP_LANGUAGE;
}
